<script setup lang="ts">
import type { AutoCompleteSuggestion } from '@libs/trip-planner-interfaces';

import {
  AutoCompleteHeader,
  AutoCompleteSuggestionsList,
} from '../autoComplete';
import type { DestinationAutocompleteType } from '../autoComplete';

interface DestinationSelectorEmits {
  (eventName: 'select-destination', suggestion: AutoCompleteSuggestion): void;
  (
    eventName: 'select-my-position',
    autocompleteType: DestinationAutocompleteType
  ): void;
  (eventName: 'clear-selection'): void;
}
const emit = defineEmits<DestinationSelectorEmits>();

interface DestinationSelectorModalProps {
  searchText: string;
  autocompleteType: DestinationAutocompleteType;
}
const props = defineProps<DestinationSelectorModalProps>();

function changeDestination(suggestion: AutoCompleteSuggestion): void {
  emit('select-destination', suggestion);
}

function selectMyPosition(): void {
  emit('select-my-position', props.autocompleteType);
}

function clearSelection(): void {
  emit('clear-selection');
}
</script>

<template>
  <div class="destination-selector">
    <AutoCompleteHeader
      :auto-complete-type="props.autocompleteType"
      :initial-search-text="props.searchText"
      :auto-focus="true"
      @clear-search-text="clearSelection"
    />
    <div class="destination-suggestions">
      <AutoCompleteSuggestionsList
        @select-suggestion="changeDestination"
        @select-my-position="selectMyPosition"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.destination-selector {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .destination-suggestions {
    margin-top: var(--spacing-24);
    overflow: auto;
  }
}
</style>
